// extracted by mini-css-extract-plugin
export default {"root":"nonotif_root__uollb"};